export const FordFBATypes = {
    none: 0,
    gold: 1,
    blue: 2,
    lincolnCPO: 3
}
